module.exports = __webpack_public_path__ + "img/Group 28.1ab6efaf.png";